import { Injectable } from '@angular/core';
import { MobileMenuActions } from '@main/mobile-menu/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class MainMobileMenuEffects {
  resetSteps$: Observable<void> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(MobileMenuActions.MOBILE_MENU_RESET_STEPS),
        map(() => {
          // const step = this.activatedRoute.snapshot.queryParams.step;
        }),
      ),
    { dispatch: false },
  );

  constructor(private actions$: Actions) {}
}
